<template>
  <footer class="footer">
    <div class="footer-glow"></div>

    <div class="footer-top">
      <!-- Brand -->
      <div class="footer-brand">
        <img src="@/assets/logo.png" alt="Venom Gym" class="footer-logo-img" />
        <div class="footer-logo-text">
          <span class="f-venom">VENOM</span>
          <span class="f-gym">GYM</span>
        </div>
        <p class="footer-tagline">Forge Your Legend.<br />Break Your Limits.</p>
        <div class="footer-socials">
          <a
            href="https://www.facebook.com/share/1DSfTz1RD8/"
            class="s-btn"
            aria-label="Facebook"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
              />
            </svg>
          </a>
          <a
            href="https://www.instagram.com/venom.gym0?igsh=YW0xczhhYTBpeW16"
            class="s-btn"
            aria-label="Instagram"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <rect x="2" y="2" width="20" height="20" rx="5" />
              <circle cx="12" cy="12" r="4" />
              <circle
                cx="17.5"
                cy="6.5"
                r="1"
                fill="currentColor"
                stroke="none"
              />
            </svg>
          </a>
          <a
            href="https://www.tiktok.com/@venom.gym3?_r=1&_t=ZS-95S0qOLLWWW"
            class="s-btn"
            aria-label="TikTok"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.34 6.34 0 00-.79-.05 6.34 6.34 0 000 12.68 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.74a4.85 4.85 0 01-1.01-.05z"
              />
            </svg>
          </a>
          <a href="#" class="s-btn" aria-label="YouTube">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"
              />
            </svg>
          </a>
        </div>
      </div>

      <!-- Quick Links -->
      <div class="footer-col">
        <h4 class="footer-heading">Quick Links</h4>
        <ul class="footer-list">
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/about">About Us</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
        </ul>
      </div>

      <!-- Programs -->
      <div class="footer-col">
        <h4 class="footer-heading">Programs</h4>
        <ul class="footer-list">
          <li><a href="#">Bodybuilding</a></li>
          <li><a href="#">Boxing & MMA</a></li>
          <li><a href="#">Kickboxing</a></li>
          <li><a href="#">Karate</a></li>
          <li><a href="#">Fitness & Cardio</a></li>
        </ul>
      </div>

      <!-- Contact Info -->
      <div class="footer-col">
        <h4 class="footer-heading">Contact</h4>
        <ul class="footer-list contact-list">
          <li>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            1 Street 18, Sidi Beshr Bahri, Alexandria
          </li>
          <li>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"
              />
            </svg>
            +220 12 87679354
          </li>
          <li>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            Sat â€“ Thu: 6AM â€“ 12AM
          </li>
        </ul>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <div class="footer-line"></div>
      <div class="footer-bottom-inner">
        <p>Â© 2026 <span>VENOM GYM</span>. All rights reserved.</p>
        <p class="footer-made">Forged with ðŸ’ª in Alexandria, Egypt</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default { name: "FooterView" };
</script>

<style scoped>
.footer {
  background: #080808;
  position: relative;
  overflow: hidden;
}

.footer-glow {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--red), transparent);
  box-shadow: 0 0 60px 10px rgba(204, 0, 0, 0.25);
}

.footer-top {
  display: grid;
  grid-template-columns: 1.4fr repeat(3, 1fr);
  gap: 48px;
  padding: 64px 6% 48px;
}

/* Brand */
.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.footer-logo-img {
  height: 70px;
  width: auto;
  filter: drop-shadow(0 0 16px rgba(204, 0, 0, 0.7));
}
.footer-logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}
.f-venom {
  font-family: "Black Ops One", cursive;
  font-size: 1.5rem;
  color: #fff;
  letter-spacing: 2px;
}
.f-gym {
  font-family: "Bebas Neue", cursive;
  font-size: 0.9rem;
  color: var(--red);
  letter-spacing: 6px;
}
.footer-tagline {
  font-family: "Rajdhani", sans-serif;
  font-size: 0.85rem;
  color: var(--grey);
  line-height: 1.6;
  letter-spacing: 1px;
}

.footer-socials {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}
.s-btn {
  width: 38px;
  height: 38px;
  border: 1px solid rgba(204, 0, 0, 0.3);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--grey);
  transition: all 0.3s;
}
.s-btn svg {
  width: 16px;
  height: 16px;
}
.s-btn:hover {
  background: var(--red);
  border-color: var(--red);
  color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(204, 0, 0, 0.4);
}

/* Columns */
.footer-col {
}
.footer-heading {
  font-family: "Bebas Neue", cursive;
  font-size: 1rem;
  letter-spacing: 3px;
  color: var(--red);
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(204, 0, 0, 0.2);
}
.footer-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.footer-list a {
  color: var(--grey);
  text-decoration: none;
  font-size: 0.88rem;
  font-family: "Rajdhani", sans-serif;
  font-weight: 600;
  letter-spacing: 1px;
  transition: all 0.25s;
  display: flex;
  align-items: center;
  gap: 6px;
}
.footer-list a::before {
  content: "";
  width: 0;
  height: 1px;
  background: var(--red);
  transition: width 0.3s;
}
.footer-list a:hover {
  color: #fff;
  padding-left: 4px;
}
.footer-list a:hover::before {
  width: 12px;
}

.contact-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: var(--grey);
  font-size: 0.85rem;
  font-family: "Cairo", sans-serif;
  line-height: 1.5;
}
.contact-list svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--red);
}

/* Bottom */
.footer-line {
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(204, 0, 0, 0.3),
    transparent
  );
}
.footer-bottom-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 6%;
  flex-wrap: wrap;
  gap: 8px;
}
.footer-bottom-inner p {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.3);
  font-family: "Rajdhani", sans-serif;
  letter-spacing: 1px;
}
.footer-bottom-inner p span {
  color: var(--red);
  font-weight: 700;
}
.footer-made {
  color: rgba(255, 255, 255, 0.2) !important;
}

@media (max-width: 900px) {
  .footer-top {
    grid-template-columns: 1fr 1fr;
    gap: 36px;
  }
}
@media (max-width: 580px) {
  .footer-top {
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 40px 6% 32px;
  }
  .footer-bottom-inner {
    flex-direction: column;
    text-align: center;
  }
}
</style>
